import {
  targetGroupsListConstants,
  targetGroupsFuseConstants,
  targetGroupsHm5Constants,
  targetGroupsUAConstants,
  targetGroupsSaConstants,
  targetGroupsVs2jen2Constants,
  targetGroupsVs2ngaConstants,
  targetGroupsHmplusConstants,
  targetGroupsByFuseConstants,
} from "../_redux-constants";
import { TargetGroupService } from "../../_services";

function getTargetGroups(queryParams) {
  function getTargetGroupsLoad() {
    return { type: targetGroupsListConstants.TARGET_GROUPS_LIST_LOADING };
  }
  function getTargetGroupsSuccess(data) {
    return {
      type: targetGroupsListConstants.TARGET_GROUPS_LIST_SUCCESS,
      data,
    };
  }
  function getTargetGroupsFailure(error) {
    return {
      type: targetGroupsListConstants.TARGET_GROUPS_LIST_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(getTargetGroupsLoad());
    return TargetGroupService.getTargetGroups(queryParams).then(
      (data) => {
        dispatch(getTargetGroupsSuccess(data));
      },
      (error) => {
        dispatch(getTargetGroupsFailure(error?.toString()));
      }
    );
  };
}

function getTargetGroupsByFuse(queryParams) {
  function getTargetGroupsLoad() {
    return { type: targetGroupsByFuseConstants.TARGET_GROUPS_BY_FUSE_LOADING };
  }
  function getTargetGroupsSuccess(data) {
    return {
      type: targetGroupsByFuseConstants.TARGET_GROUPS_BY_FUSE_SUCCESS,
      data,
    };
  }
  function getTargetGroupsFailure(error) {
    return {
      type: targetGroupsByFuseConstants.TARGET_GROUPS_BY_FUSE_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(getTargetGroupsLoad());
    return TargetGroupService.getTargetGroupsByFuse(queryParams).then(
      (data) => {
        dispatch(getTargetGroupsSuccess(data));
      },
      (error) => {
        dispatch(getTargetGroupsFailure(error?.toString()));
      }
    );
  };
}

function targetGroupsFuseList() {
  function targetGroupsFuseListLoad() {
    return {
      type: targetGroupsFuseConstants.TARGET_GROUPS_FUSE_LIST_LOADING,
    };
  }
  function targetGroupsFuseListSuccess(data) {
    return {
      type: targetGroupsFuseConstants.TARGET_GROUPS_FUSE_LIST_SUCCESS,
      data,
    };
  }
  function targetGroupsFuseListFailure(error) {
    return {
      type: targetGroupsFuseConstants.TARGET_GROUPS_FUSE_LIST_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(targetGroupsFuseListLoad());
    TargetGroupService.getFuseTargetGroups().then(
      (data) => {
        dispatch(targetGroupsFuseListSuccess(data));
      },
      (error) => {
        dispatch(targetGroupsFuseListFailure(error?.toString()));
      }
    );
  };
}

function targetGroupsHm5List() {
  function targetGroupsHm5ListLoad() {
    return {
      type: targetGroupsHm5Constants.TARGET_GROUPS_HM5_LIST_LOADING,
    };
  }
  function targetGroupsHm5ListSuccess(data) {
    return {
      type: targetGroupsHm5Constants.TARGET_GROUPS_HM5_LIST_SUCCESS,
      data,
    };
  }
  function targetGroupsHm5ListFailure(error) {
    return {
      type: targetGroupsHm5Constants.TARGET_GROUPS_HM5_LIST_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(targetGroupsHm5ListLoad());
    TargetGroupService.getHm5TargetGroups().then(
      (data) => {
        dispatch(targetGroupsHm5ListSuccess(data));
      },
      (error) => {
        dispatch(targetGroupsHm5ListFailure(error?.toString()));
      }
    );
  };
}

function targetGroupsHmplusList() {
  function targetGroupsHmplusListLoad() {
    return {
      type: targetGroupsHmplusConstants.TARGET_GROUPS_HMPLUS_LIST_LOADING,
    };
  }
  function targetGroupsHmplusListSuccess(data) {
    return {
      type: targetGroupsHmplusConstants.TARGET_GROUPS_HMPLUS_LIST_SUCCESS,
      data,
    };
  }
  function targetGroupsHm5ListFailure(error) {
    return {
      type: targetGroupsHmplusConstants.TARGET_GROUPS_HMPLUS_LIST_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(targetGroupsHmplusListLoad());
    TargetGroupService.getHmplusTargetGroups().then(
      (data) => {
        dispatch(targetGroupsHmplusListSuccess(data));
      },
      (error) => {
        dispatch(targetGroupsHm5ListFailure(error?.toString()));
      }
    );
  };
}

function targetGroupsUAList() {
  function targetGroupsUAListLoad() {
    return {
      type: targetGroupsUAConstants.TARGET_GROUPS_UA_LIST_LOADING,
    };
  }
  function targetGroupsUAListSuccess(data) {
    return {
      type: targetGroupsUAConstants.TARGET_GROUPS_UA_LIST_SUCCESS,
      data,
    };
  }
  function targetGroupsUAListFailure(error) {
    return {
      type: targetGroupsUAConstants.TARGET_GROUPS_UA_LIST_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(targetGroupsUAListLoad());
    TargetGroupService.getUATargetGroups().then(
      (data) => {
        dispatch(targetGroupsUAListSuccess(data));
      },
      (error) => {
        dispatch(targetGroupsUAListFailure(error?.toString()));
      }
    );
  };
}

function targetGroupsSaList() {
  function targetGroupsSaListLoad() {
    return {
      type: targetGroupsSaConstants.TARGET_GROUPS_SA_LIST_LOADING,
    };
  }
  function targetGroupsSaListSuccess(data) {
    return {
      type: targetGroupsSaConstants.TARGET_GROUPS_SA_LIST_SUCCESS,
      data,
    };
  }
  function targetGroupsSaListFailure(error) {
    return {
      type: targetGroupsSaConstants.TARGET_GROUPS_SA_LIST_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(targetGroupsSaListLoad());
    TargetGroupService.getSaTargetGroups().then(
      (data) => {
        dispatch(targetGroupsSaListSuccess(data));
      },
      (error) => {
        dispatch(targetGroupsSaListFailure(error?.toString()));
      }
    );
  };
}

function targetGroupsVs2jen2List() {
  function targetGroupsVs2jen2ListLoad() {
    return {
      type: targetGroupsVs2jen2Constants.TARGET_GROUPS_VS2JEN2_LIST_LOADING,
    };
  }
  function targetGroupsVs2jen2ListSuccess(data) {
    return {
      type: targetGroupsVs2jen2Constants.TARGET_GROUPS_VS2JEN2_LIST_SUCCESS,
      data,
    };
  }
  function targetGroupsVs2jen2ListFailure(error) {
    return {
      type: targetGroupsVs2jen2Constants.TARGET_GROUPS_VS2JEN2_LIST_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(targetGroupsVs2jen2ListLoad());
    TargetGroupService.getVs2jen2TargetGroups().then(
      (data) => {
        dispatch(targetGroupsVs2jen2ListSuccess(data));
      },
      (error) => {
        dispatch(targetGroupsVs2jen2ListFailure(error?.toString()));
      }
    );
  };
}

function targetGroupsVs2ngaList() {
  function targetGroupsVs2ngaListLoad() {
    return {
      type: targetGroupsVs2ngaConstants.TARGET_GROUPS_VS2NGA_LIST_LOADING,
    };
  }
  function targetGroupsVs2ngaListSuccess(data) {
    return {
      type: targetGroupsVs2ngaConstants.TARGET_GROUPS_VS2NGA_LIST_SUCCESS,
      data,
    };
  }
  function targetGroupsVs2ngaListFailure(error) {
    return {
      type: targetGroupsVs2ngaConstants.TARGET_GROUPS_VS2NGA_LIST_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(targetGroupsVs2ngaListLoad());
    TargetGroupService.getVs2ngaTargetGroups().then(
      (data) => {
        dispatch(targetGroupsVs2ngaListSuccess(data));
      },
      (error) => {
        dispatch(targetGroupsVs2ngaListFailure(error?.toString()));
      }
    );
  };
}

export const targetGroupsActions = {
  getTargetGroups,
  getTargetGroupsByFuse,
  targetGroupsFuseList,
  targetGroupsHm5List,
  targetGroupsUAList,
  targetGroupsSaList,
  targetGroupsVs2jen2List,
  targetGroupsVs2ngaList,
  targetGroupsHmplusList,
};
